<template>
  <mdb-container class="showcase">
    <mdb-row>
      <service-showcase-item
        v-for="(service, index) in services"
        :key="index"
        :index="index"
        :serviceImage="service.image"
        :serviceImageAlt="service.imageAlt"
        :serviceTitle="service.title"
        :serviceBody="service.body"
        v-animateOnScroll="{animation: 'fadeIn', delay: index*75, position:-40}" />
    </mdb-row>
  </mdb-container>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  animateOnScroll
} from 'mdbvue'
import ServiceShowcaseItem from '@/components/ServiceShowcaseItem.vue'

export default {
  name: 'ServicesShowcase',
  props: {
    services: Array
  },
  components: {
    mdbContainer,
    mdbRow,
    ServiceShowcaseItem
  },
  directives: {
    animateOnScroll
  }
}
</script>

<style scoped>
.showcase {
  padding-top: 75px;
  padding-bottom: 50px;
}
</style>